import { HStack, SegmentGroup } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { useEffect, useState } from 'react'
import { IoDocumentText } from 'react-icons/io5'
import { ACQUIRING_TYPE_LABEL } from 'shared/constants/payments'
import { userCardStore } from 'shared/store/userCard'
import { getDateReadFormat, getDateTimeReadFormat } from 'shared/utils/dateFormatting'
import { getRangeDateFromType } from './IncomingTransfers.utils'
import { Button, Modal, Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import { HeadingItem, ItemIcon, ItemLink, ItemText } from 'uikit/Snippets'
import { GridField, GridFieldItem } from 'uikit/layout'
import { RangeDateModal } from './elements/RangeDateModal'
import { LimitPopup } from './elements/limitPopup'
import { useIncomingTransfers } from './services/useIncomingTransfers'
import moment from 'moment'
import { getDateToSubmit } from 'uikit/InputDate/dateFormatting'

export const IncomingTransfers = () => {
  const { incomingTransfers, ...item } = useStore(userCardStore)
  const { fromDate, toDate, dateRange, list, loading, limit } = incomingTransfers
  const [data, setData] = useState(null)
  const { mutate: getIncomingTransfers, isPending } = useIncomingTransfers(item.id)
  const rangeDate = getRangeDateFromType(dateRange)

  useEffect(() => {
    userCardStore.setState((state) => {
      return {
        ...state,
        incomingTransfers: {
          ...state.incomingTransfers,
          ...rangeDate,
        },
      }
    })
  }, [dateRange])

  const handleChangeRange = (value) => {
    userCardStore.setState((state) => {
      return {
        ...state,
        incomingTransfers: {
          ...state.incomingTransfers,
          dateRange: value,
        },
      }
    })
  }

  const handleModalOpen = (item) => {
    setData(item)
  }

  const handleModalClose = () => {
    setData(null)
  }

  const handleGetList = async (params) => {
    getIncomingTransfers({
      fromDate,
      toDate: getDateToSubmit(moment(toDate).endOf('day')),
      limit,
      ...params,
    })

    return
  }

  useEffect(() => {
    if (item.id) {
      handleGetList({ transferType: 'ACQUIRING_ONLY_TRANSFER' })
    }
  }, [])

  return (
    <>
      <HStack gap={3} mb="30px">
        <SegmentGroup.Root
          value={dateRange}
          defaultValue={dateRange}
          onValueChange={(e) => handleChangeRange(e.value)}
        >
          <SegmentGroup.Indicator />
          <SegmentGroup.Items
            h="36px"
            cursor="pointer"
            items={[
              { label: 'Неделя', value: 'week' },
              { label: 'Месяц', value: 'month' },
              { label: 'Год', value: 'year' },
            ]}
          />
        </SegmentGroup.Root>
        <RangeDateModal label={`${getDateReadFormat(fromDate)} – ${getDateReadFormat(toDate)}`} />
        <LimitPopup />
        <Button colorPalette="orange" size="sm" onClick={() => handleGetList()}>
          Запросить
        </Button>
      </HStack>
      <Snippets
        columns="42px 180px 180px 180px 220px 1fr"
        //itemWidth="1440px"
      >
        <SnippetsHeading>
          <HeadingItem />
          <HeadingItem>Сумма</HeadingItem>
          <HeadingItem>Валюта</HeadingItem>
          <HeadingItem>Дата</HeadingItem>
          <HeadingItem>Тип пополнения</HeadingItem>
        </SnippetsHeading>
        <SnippetsList
          activePage={0}
          totalPages={0}
          data={list}
          isLoading={isPending}
          scrollableTarget="scrollableCardContainer"
          textIsEmpty={loading ? 'Загрузка данных...' : 'Нет данных за выбранный период'}
          keyField="index"
        >
          {(item) => (
            <SnippetsItem onClick={() => handleModalOpen(item)} cursor="pointer">
              <ItemIcon IconComponent={IoDocumentText} />
              <ItemLink>
                <b>{item.amount}</b>
              </ItemLink>
              <ItemText>{item.currency}</ItemText>
              <ItemText>{getDateTimeReadFormat(item.transDate)}</ItemText>
              <ItemText>{ACQUIRING_TYPE_LABEL[item.transferType]}</ItemText>
            </SnippetsItem>
          )}
        </SnippetsList>
      </Snippets>
      <Modal isOpen={data !== null} onClose={handleModalClose} title="Платеж">
        <GridField>
          <GridFieldItem label="Сумма" isLoading={false} isReady>
            <b>{data?.amount}</b>
          </GridFieldItem>
          <GridFieldItem label="Комиссия" isLoading={false} isReady>
            {data?.commission}
          </GridFieldItem>
          <GridFieldItem label="Валюта" isLoading={false} isReady>
            {data?.currency}
          </GridFieldItem>
          <GridFieldItem label="ID операции" isLoading={false} isReady>
            {data?.operationId}
          </GridFieldItem>
          <GridFieldItem label="Дата" isReady isLoading={false}>
            {getDateTimeReadFormat(data?.transDate)}
          </GridFieldItem>
          <GridFieldItem label="Тип пополнения" isLoading={false} isReady>
            {ACQUIRING_TYPE_LABEL[data?.transferType]}
          </GridFieldItem>
          <GridFieldItem label="Комментарий" isReady isLoading={false}>
            {data?.detail}
          </GridFieldItem>
        </GridField>
      </Modal>
    </>
  )
}
